import { query, redirect } from "@solidjs/router";
import { getCookie } from "./utils.js";

// This is the query function that fetches user data.
// The router understands how to handle redirects thrown from here.
export const getCurrentUser = query(async () => {
  const token = getCookie("token");

  if (!token) {
    // No token, so we know we need to log in.
    throw redirect(`/login`);
  }

  let response;
  try {
    response = await fetch("/api/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    // This catches network errors.
    console.error("Network error fetching user:", error);
    throw redirect("/login");
  }

  if (response.status === 401) {
    // Token is invalid/expired, clear it and redirect.
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    throw redirect(`/login`);
  }

  if (!response.ok) {
    // Another server error occurred.
    console.error(`Failed to fetch user: ${response.statusText}`);
    throw redirect("/login");
  }

  // All good, return user data.
  return await response.json();
}, "currentUser"); // "currentUser" is the cache key for this query.

// The preload function's only job is to trigger the query.
export function protectedLoader() {
  void getCurrentUser();
}
export const getUsers = query(async () => {
  const token = getCookie("token");
  const response = await fetch("/api/users", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch users");
  }
  return await response.json();
}, "users");

// Role helpers. Pure functions — caller passes the user object (or null).
// Admin always has access to every role check.
export const hasRole = (user, role) =>
  user?.roles?.some((r) => r.role === "admin" || r.role === role) ?? false;

export const isAdmin = (user) => hasRole(user, "admin");
